'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'selection';

var Selection = function (_React$Component) {
  _inherits(Selection, _React$Component);

  function Selection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Selection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Selection.__proto__ || Object.getPrototypeOf(Selection)).call.apply(_ref, [this].concat(args))), _this), _this.renderIcon = function (icon, showIcon) {
      if (showIcon && icon) {
        return _react2.default.createElement('img', { src: icon.src, alt: icon.alt, className: ORGANISM_NAME + '__icon' });
      }
      return null;
    }, _this.renderHeadline = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$headline = _ref2.headline,
          headline = _ref2$headline === undefined ? '' : _ref2$headline,
          _ref2$headlineClass = _ref2.headlineClass,
          headlineClass = _ref2$headlineClass === undefined ? '' : _ref2$headlineClass,
          _ref2$level = _ref2.level,
          level = _ref2$level === undefined ? '4' : _ref2$level,
          _ref2$idx = _ref2.idx,
          idx = _ref2$idx === undefined ? '' : _ref2$idx,
          _ref2$show = _ref2.show,
          show = _ref2$show === undefined ? true : _ref2$show;

      if (show && headline) {
        return _react2.default.createElement(
          _heading2.default,
          { key: idx, level: level, className: headlineClass },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderMainHeadline = function (headline) {
      if (headline && headline.text) {
        return _react2.default.createElement(
          'div',
          { className: 'row' },
          _this.renderHeadline({
            headline: headline,
            headlineClass: 'text-xs-center ' + ORGANISM_NAME + '__headline-main',
            level: '2'
          })
        );
      }
      return null;
    }, _this.renderGroup = function (group) {
      var groups = [];
      if (group) {
        for (var i = 0; i < group.length; i += 1) {
          var elem = group[i];
          if (elem.itemHeadline) {
            groups.push(_this.renderHeadline({
              headline: elem.itemHeadline,
              headlineClass: 'pp-sans-small-regular ' + ORGANISM_NAME + '__headline-para',
              idx: i
            }));
          }
          if (elem.itemParagraph) {
            groups.push(_react2.default.createElement(
              'p',
              { className: ORGANISM_NAME + '__para', key: ORGANISM_NAME + '__para-' + i },
              htmlToReactParser.parse(elem.itemParagraph.text)
            ));
          }
        }
        return groups;
      }
      return null;
    }, _this.renderCta = function (cta, config) {
      if (cta) {
        var type = {
          secondary: 'outline-blue',
          primary: 'blue'
        };
        var fptiData = {
          secondary: 'Selection-ScndCTA-' + cta.text,
          primary: 'Selection-PrmryCTA-' + cta.text,
          hatch: 'Selection-HtchLnk-' + cta.text
        };
        var fpti = fptiData[config.ctaType] || fptiData.secondary;
        var color = type[config.ctaType] || type.secondary;
        var classes = (0, _classnames2.default)(ORGANISM_NAME + '__cta', {
          'center-block': config.centerText === true
        });
        var targetValue = cta.target || '_self';
        if (config.ctaType === 'hatch') {
          return _react2.default.createElement(
            'a',
            {
              id: cta.id,
              href: cta.href,
              className: ORGANISM_NAME + '__hatch-link',
              'data-pa-click': fpti
            },
            cta.text
          );
        }
        return _react2.default.createElement(
          _button2.default,
          {
            color: color,
            href: cta.href,
            className: classes,
            fpti: fpti,
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    }, _this.renderMobilePanels = function (panels, config) {
      if (panels) {
        var classes = (0, _classnames2.default)('col-sm-12 col-md-6 col-lg-6 ' + ORGANISM_NAME + '__panel', {
          'text-xs-center': config.centerText === true
        });

        var panelsArr = panels.map(function (elem, idx) {
          return _react2.default.createElement(
            'div',
            {
              className: classes,
              key: idx
            },
            _this.renderIcon(elem.icon, config.showIcon),
            _this.renderHeadline({
              headline: elem.panelHeadline,
              headlineClass: ORGANISM_NAME + '__subheadline',
              level: '3',
              idx: idx,
              show: !!config.showSubheadline
            }),
            _this.renderGroup(elem.group),
            _this.renderCta(elem.cta, config)
          );
        });
        return _react2.default.createElement(
          'div',
          { className: 'row hidden-md-up' },
          panelsArr
        );
      }
      return null;
    }, _this.renderIconRow = function (panels, config) {
      return panels.map(function (elem, idx) {
        return _react2.default.createElement(
          'div',
          {
            className: 'col-md-6',
            key: idx
          },
          _this.renderIcon(elem.icon, config.showIcon)
        );
      });
    }, _this.renderHeaderRow = function (panels, config) {
      return panels.map(function (elem, idx) {
        return _react2.default.createElement(
          'div',
          {
            className: 'col-md-6',
            key: idx
          },
          _this.renderHeadline({
            headline: elem.panelHeadline,
            headlineClass: ORGANISM_NAME + '__subheadline',
            level: '3',
            idx: idx,
            show: !!config.showSubheadline
          })
        );
      });
    }, _this.renderGroupRow = function (panels) {
      var headlineLevel = '4';
      var headlineClass = 'pp-sans-small-regular ' + ORGANISM_NAME + '__headline-para';
      var numberOfRows = panels.reduce(function (pre, cur) {
        return pre.group.length > cur.group.length ? pre.group.length : cur.group.length;
      });
      var rows = [];

      var _loop = function _loop(i) {
        var group = panels.map(function (elem, idx) {
          var groupMarkup = null;
          if (elem.group[i]) {
            groupMarkup = _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _heading2.default,
                { level: headlineLevel, className: headlineClass },
                htmlToReactParser.parse(elem.group[i].itemHeadline.text)
              ),
              _react2.default.createElement(
                'p',
                { className: ORGANISM_NAME + '__para' },
                htmlToReactParser.parse(elem.group[i].itemParagraph.text)
              )
            );
          }
          return _react2.default.createElement(
            'div',
            {
              className: 'col-sm-6',
              key: idx
            },
            groupMarkup
          );
        });
        rows.push(_react2.default.createElement(
          'div',
          { className: 'row', key: i },
          group
        ));
      };

      for (var i = 0; i < numberOfRows; i += 1) {
        _loop(i);
      }
      return rows;
    }, _this.renderCtaRow = function (panels, config) {
      var group = panels.map(function (elem, idx) {
        return _react2.default.createElement(
          'div',
          {
            className: 'col-sm-6',
            key: ORGANISM_NAME + '__cta-' + idx
          },
          _this.renderCta(elem.cta, config)
        );
      });
      return group;
    }, _this.renderDesktopPanels = function (panels, config) {
      if (panels) {
        var classes = (0, _classnames2.default)('hidden-sm-down', {
          'text-xs-center': config.centerText === true
        });
        return _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _this.renderIconRow(panels, config)
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _this.renderHeaderRow(panels, config)
          ),
          _this.renderGroupRow(panels, config),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _this.renderCtaRow(panels, config)
          )
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Selection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;


      var panels = [content.panel1, content.panel2];

      var selectionClasses = (0, _classnames2.default)(ORGANISM_NAME, className);
      return _react2.default.createElement(
        'section',
        { id: config.id, className: selectionClasses, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.renderMainHeadline(content.headline),
          this.renderMobilePanels(panels, config),
          this.renderDesktopPanels(panels, config)
        )
      );
    }
  }]);

  return Selection;
}(_react2.default.Component);

exports.default = Selection;


var panelPropTypes = _propTypes2.default.shape({
  icon: _propTypes2.default.shape({
    src: _propTypes2.default.string.isRequired,
    alt: _propTypes2.default.string
  }),
  panelHeadline: _propTypes2.default.shape({
    text: _propTypes2.default.string
  }),
  group: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    itemHeadline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    itemParagraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  })).isRequired,
  cta: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    href: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    target: _propTypes2.default.oneOf(['_self', '_blank']).isRequired
  }).isRequired
}).isRequired;

Selection.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    showMainHeadline: _propTypes2.default.bool,
    showIcon: _propTypes2.default.bool,
    showSubheadline: _propTypes2.default.bool,
    centerText: _propTypes2.default.bool,
    ctaType: _propTypes2.default.oneOf(['secondary', 'primary', 'hatch'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    panel1: panelPropTypes,
    panel2: panelPropTypes
  }),
  className: _propTypes2.default.string
};

Selection.defaultProps = {
  config: {
    id: '',
    showSubheadline: true,
    showIcon: false,
    centerText: false,
    ctaType: 'secondary'
  },
  content: {
    headline: {
      text: '50 characters maximum to limit mobile scroll.'
    },
    panel1: {
      icon: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/au/icons/AU-icon-payflow-green.svg',
        alt: 'Alternate text'
      },
      panelHeadline: {
        text: '25 characters maximum'
      },
      group: [{
        itemHeadline: {
          text: '36-character line lengths'
        },
        itemParagraph: {
          text: '138 characters maximum for text or approximately ' + '4 lines of text or less. Sentence case with normal punctuation.'
        }
      }, {
        itemHeadline: {
          text: '36-character line lengths'
        },
        itemParagraph: {
          text: '138 characters maximum for text or approximately ' + '4 lines of text or less. Sentence case with normal punctuation.'
        }
      }],
      cta: {
        id: '',
        href: '#',
        text: '29 characters maximum',
        target: '_self'
      }
    },
    panel2: {
      icon: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/au/icons/AU-icon-payflow-green.svg',
        alt: 'Alternate text'
      },
      panelHeadline: {
        text: '25 characters maximum'
      },
      group: [{
        itemHeadline: {
          text: '36-character line lengths'
        },
        itemParagraph: {
          text: '138 characters maximum for text or approximately ' + '4 lines of text or less. Sentence case with normal punctuation.'
        }
      }, {
        itemHeadline: {
          text: '36-character line lengths'
        },
        itemParagraph: {
          text: '138 characters maximum for text or approximately ' + '4 lines of text or less. Sentence case with normal punctuation.'
        }
      }],
      cta: {
        id: '',
        href: '#',
        text: '29 characters maximum',
        target: '_self'
      }
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/selection/jsx/Selection.js
// module id = 1138
// module chunks = 4